(function () {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function itemPrice(item) {
    return typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
  }

  // 7 Oct 2026 team review: lines the sale discounts never cover don't count towards a sale tier or
  // (on sale days) the gift. Mirrors bf-2026-eligible and discount-eligible-system (read live 7 Oct):
  // Shipping Protection, Salon Service (consults), Gift Card and Skincare types, any gift card, the
  // free gifts, and the Liner Duo (tag bf-2026-exclude; cart.js has no tags, so matched by title).
  var SKIP_TYPES = { 'shipping protection': 1, 'salon service': 1, 'gift card': 1, 'skincare': 1 };
  function notDiscounted(item) {
    if (item.gift_card) return true;
    if (item.handle === 'shipping-protection') return true;
    if (item.properties && item.properties._shipping_protection) return true;
    if (SKIP_TYPES[String(item.product_type || '').toLowerCase()]) return true;
    return /Mystery Gift|Premium Gift|Liner Duo/i.test(String(item.product_title || item.title || ''));
  }

  function CartRewardsBar(el) {
    this.el = el;

    var dataEl = el.querySelector('[data-rewards-data]');
    if (!dataEl) return;

    try {
      this.config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // Tiers keep the order they're arranged in the theme editor (left to right),
    // which is also the order their icons are laid out in the DOM.
    this.tiers = (this.config.tiers || []).slice();

    // Thresholds are authored in the shop currency (AUD), but /cart.js totals
    // arrive in the shopper's presentment currency. Scale the thresholds by
    // Shopify's own conversion rate so a US shopper's $150 AUD tier isn't
    // silently treated as USD 150.
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (rate && isFinite(rate) && rate > 0 && rate !== 1) {
      this.tiers = this.tiers.map(function (tier) {
        // US tiers (26 Sep 2026) are already in the cart currency: never convert.
        if (tier.fixed_presentment) return tier;
        var scaled = Object.assign({}, tier);
        scaled.threshold_cents = Math.round(tier.threshold_cents * rate);
        return scaled;
      });
    }

    // 27 Sep 2026: date-gated thresholds can change the order (Mon 30 Nov: world shipping
    // drops to A$125, under the A$150 gift). Keep tiers lowest first, in data and on screen.
    this.tiers.sort(function (a, b) { return a.threshold_cents - b.threshold_cents; });
    var tiersWrap = el.querySelector('.cart-rewards-bar__tiers');
    if (tiersWrap) {
      this.tiers.forEach(function (tier) {
        var tierEl = tiersWrap.querySelector('[data-tier-id="' + tier.id + '"]');
        if (tierEl) tiersWrap.appendChild(tierEl);
      });
    }

    this.fillEl = el.querySelector('[data-rewards-fill]');
    this.messageEl = el.querySelector('[data-rewards-message]');

    this.tierEls = {};
    el.querySelectorAll('[data-tier-id]').forEach(function (tierEl) {
      this.tierEls[tierEl.dataset.tierId] = tierEl;
    }.bind(this));

    this.busy = false;
    this.pending = false;

    // When the bar is shown in more than one place (drawer + cart page),
    // only the first instance manages free-gift add/remove so gifts can't
    // be added twice. Every instance still renders the progress display.
    if (!CartRewardsBar.giftOwner) {
      CartRewardsBar.giftOwner = this;
    }

    this.refresh();

    document.addEventListener('ajaxProduct:added', this.refresh.bind(this));
    document.addEventListener('cart:updated', this.refresh.bind(this));
  }

  CartRewardsBar.prototype.getSubtotal = function (cart) {
    // On sale days (a Black Friday or early-access config is present) the gift distance skips the
    // lines the discounts skip, so the bar never promises a gift checkout won't match. Everyday: unchanged.
    var saleDay = !!(this.config && this.config.bf && this.config.bf.tiers);
    return cart.items.reduce(function (sum, item) {
      if (item.properties && item.properties._reward_tier) return sum;
      if (saleDay && notDiscounted(item)) return sum;
      return sum + itemPrice(item);
    }, 0);
  };

  CartRewardsBar.prototype.refresh = function () {
    if (this.busy) {
      this.pending = true;
      return;
    }
    this.busy = true;

    var url = routes().cart || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(this.handleCart.bind(this))
      .catch(function () {})
      .then(function () {
        this.busy = false;
        if (this.pending) {
          this.pending = false;
          this.refresh();
        }
      }.bind(this));
  };

  CartRewardsBar.prototype.handleCart = function (cart) {
    var subtotal = this.getSubtotal(cart);
    // Hide the bar when nothing in the cart ships, e.g. only the $50 lash
    // consultation (Shirley, 30 Sep 2026). Reward gifts, $0 lines and
    // Shipping Protection don't count as shippable.
    var ships = cart.items.some(function (item) {
      return item.requires_shipping !== false && itemPrice(item) > 0 &&
        !(item.properties && (item.properties._reward_tier || item.properties._shipping_protection)) &&
        item.handle !== 'shipping-protection';
    });
    this.el.style.display = ships ? '' : 'none';
    this.render(subtotal);
    this.renderBf(cart);
    return this.syncGifts(cart, subtotal);
  };

  // Icons sit in equal-width flex columns, so tier i (0-indexed) of n is
  // centered at (2i+1)/(2n) of the track's width. The fill has to line up
  // with that same math, interpolating between two tiers' icon positions
  // as the cart subtotal moves between their thresholds.
  CartRewardsBar.prototype.iconPosition = function (index) {
    var n = this.tiers.length;
    if (n <= 1) return 100;
    return ((2 * index + 1) / (2 * n)) * 100;
  };

  CartRewardsBar.prototype.fillPercent = function (subtotal) {
    var tiers = this.tiers;
    var n = tiers.length;
    if (!n) return 0;

    if (n === 1) {
      return Math.min(100, (subtotal / tiers[0].threshold_cents) * 100);
    }

    var first = tiers[0];
    var last = tiers[n - 1];

    if (subtotal <= 0) return 0;

    if (subtotal < first.threshold_cents) {
      return this.iconPosition(0) * (subtotal / first.threshold_cents);
    }

    if (subtotal >= last.threshold_cents) {
      return 100;
    }

    for (var i = 0; i < n - 1; i++) {
      var lower = tiers[i];
      var upper = tiers[i + 1];
      if (subtotal >= lower.threshold_cents && subtotal < upper.threshold_cents) {
        var frac = (subtotal - lower.threshold_cents) / (upper.threshold_cents - lower.threshold_cents);
        var lowerPos = this.iconPosition(i);
        var upperPos = this.iconPosition(i + 1);
        return lowerPos + frac * (upperPos - lowerPos);
      }
    }

    return 100;
  };

  CartRewardsBar.prototype.render = function (subtotal) {
    if (this.fillEl) {
      this.fillEl.style.width = this.fillPercent(subtotal) + '%';
    }

    var nextTier = null;
    this.tiers.forEach(function (tier) {
      var unlocked = subtotal >= tier.threshold_cents;
      var tierEl = this.tierEls[tier.id];
      if (tierEl) {
        tierEl.classList.toggle('is-unlocked', unlocked);
      }
      if (!unlocked && !nextTier) {
        nextTier = tier;
      }
    }.bind(this));

    if (!this.messageEl || !this.tiers.length) return;

    if (nextTier) {
      var remaining = nextTier.threshold_cents - subtotal;
      this.messageEl.innerHTML = (this.config.progressTemplate || 'Add {{ amount }} more to get {{ label }}')
        .replace('{{ amount }}', '<strong>' + formatMoney(remaining) + '</strong>')
        .replace('{{ label }}', '<strong>' + nextTier.label + '</strong>');
    } else {
      this.messageEl.innerHTML = this.config.unlockedTemplate || "You've unlocked every reward!";
    }
  };

  // Singles Day / Black Friday 2026 line (Artie, 27 Sep 2026). Config comes from
  // sections/cart-rewards-bar.liquid ("bf"), only while a Black Friday phase is running.
  //   mode "tiers": live progress to the next EXTRA 15/20/25% tier. Measured on the price
  //     before discounts (the tier minimum is checked before the tier itself comes off),
  //     skipping the free reward gifts.
  //   mode "text": the early-access reminder. 27 Sep night: when the visitor arrived from an
  //     early-access email (html.ybf-ea-you, set by yp-bf-promo.liquid from _kx / ybf=ea), the
  //     line also gets an ESTIMATE of the saving, same sum as the Black Friday week line.
  CartRewardsBar.prototype.renderBf = function (cart) {
    var el = this.el.querySelector('[data-ybf-cart]');
    var bf = this.config && this.config.bf;
    if (!el) return;
    if (!bf || (bf.end && Date.now() / 1000 >= bf.end)) { el.hidden = true; return; }
    var slot = null;
    if (bf.mode === 'singles') { this.renderSingles(cart, el, bf); return; }
    if (bf.mode === 'text') {
      el.innerHTML = bf.html; el.hidden = false;
      slot = el.querySelector('[data-ybf-ea-save]');
      if (!slot || !bf.tiers || !document.documentElement.classList.contains('ybf-ea-you')) return;
    } else if (bf.mode !== 'tiers') { el.hidden = true; return; }

    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (!rate || !isFinite(rate) || rate <= 0) rate = 1;
    var tiers = (bf.tiers || []).map(function (t) {
      return { cents: bf.fixed_presentment ? t[0] : Math.round(t[0] * rate), pct: t[1] };
    });
    var total = cart.items.reduce(function (sum, item) {
      if (item.properties && item.properties._reward_tier) return sum;
      if (notDiscounted(item)) return sum;
      var p = typeof item.original_line_price === 'number' ? item.original_line_price : item.line_price;
      return sum + p;
    }, 0);
    if (!total || !tiers.length) { if (!slot) el.hidden = true; return; }

    // The amount left is in the shopper's own cart currency, so label it with that currency.
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    var SYM = { AUD: bf.cur || '$', USD: 'US$', NZD: 'NZ$', CAD: 'CA$', GBP: '\u00a3', SGD: 'S$', MYR: 'RM', EUR: '\u20ac' };
    var sym = SYM[active] || (active + ' ');
    function money(cents) {
      var v = cents / 100;
      var txt = (Math.round(v) === v) ? String(v) : v.toFixed(2);
      return sym + txt;
    }
    var got = null, next = null;
    tiers.forEach(function (t) {
      if (total >= t.cents) got = t;
      else if (!next) next = t;
    });
    var html;
    if (slot) {
      slot.innerHTML = got
        ? ' About <strong>' + money(Math.round(total * got.pct / 100)) + ' off</strong> this cart.'
        : ' Add <strong>' + money(tiers[0].cents - total) + '</strong> more for ' + tiers[0].pct + '% off.';
      return;
    }
    if (!got) {
      html = 'Spend <strong>' + money(next.cents - total) + '</strong> more for EXTRA ' + next.pct + '% off.';
    } else if (next) {
      html = '<strong>EXTRA ' + got.pct + '% off</strong> unlocked. Spend <strong>' + money(next.cents - total) + '</strong> more for ' + next.pct + '%.';
    } else {
      html = '<strong>EXTRA ' + got.pct + '% off</strong> unlocked. That\'s the top tier.';
    }
    // 6 Oct 2026: the end of Black Friday (Sun 29 Nov at midnight), set by the Liquid on days before Monday.
    if (bf.after) html += ' <span class="ybf-cart__end">' + String(bf.after).replace(/</g, '&lt;') + '</span>';
    el.innerHTML = html;
    el.hidden = false;
  };

  // Singles Day 11.11 (8 Oct 2026). Everything is in except gift cards, Shipping Protection, salon
  // consults and the free gifts (skincare and the Liner Duo ARE in on Singles Day). The saving is
  // Shopify's own Singles Day allocation when the cart has one (the automatic discount is applied in
  // the cart, so line prices and the subtotal already show it); before that, 11% of the eligible lines.
  CartRewardsBar.prototype.renderSingles = function (cart, el, bf) {
    var real = 0, base = 0;
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._reward_tier) return;
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var t = (a.discount_application && a.discount_application.title) || '';
        if (/singles|11\.11/i.test(t)) real += a.amount;
      });
      if (item.gift_card || item.handle === 'shipping-protection') return;
      if (item.properties && item.properties._shipping_protection) return;
      var type = String(item.product_type || '').toLowerCase();
      if (type === 'shipping protection' || type === 'salon service' || type === 'gift card') return;
      if (/Mystery Gift|Premium Gift/i.test(String(item.product_title || item.title || ''))) return;
      base += typeof item.original_line_price === 'number' ? item.original_line_price : item.line_price;
    });
    var save = real || Math.round(base * (bf.pct || 11) / 100);
    if (!save) { el.hidden = true; return; }
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    var SYM = { AUD: '$', USD: 'US$', NZD: 'NZ$', CAD: 'CA$', GBP: '\u00a3', SGD: 'S$', MYR: 'RM', EUR: '\u20ac' };
    var amt = (SYM[active] || (active + ' ')) + (save / 100).toFixed(2);
    var html = '<strong>EXTRA ' + (bf.pct || 11) + '% off</strong> applied automatically. You save <strong>' + amt + '</strong>. No code needed.';
    if (bf.after) html += ' <span class="ybf-cart__end">' + String(bf.after).replace(/</g, '&lt;') + '</span>';
    el.innerHTML = html;
    el.hidden = false;
  };

  CartRewardsBar.prototype.syncGifts = function (cart, subtotal) {
    // Only the designated owner touches the cart, to avoid double-adding
    // gifts when the bar renders in both the drawer and the cart page.
    if (CartRewardsBar.giftOwner !== this) return Promise.resolve();

    var steps = [];
    var giftVariantIds = {};

    this.tiers.forEach(function (tier) {
      if (tier.variant_id) giftVariantIds[String(tier.variant_id)] = true;
    });

    // Guard (14 Sep 2026): a reward gift is only ever the one line this bar
    // added. Any copy of a gift variant without the _reward_tier tag (added
    // from the product page or a cart link) is removed.
    // Tier ids and gift variants the bar currently offers (27 Sep 2026: tiers can swap by date,
    // e.g. the Premium Gift on Sun 29 Nov carries id "<block>-premium").
    var liveTier = {};
    this.tiers.forEach(function (tier) {
      if (tier.variant_id) liveTier[tier.id] = String(tier.variant_id);
    });

    cart.items.forEach(function (item) {
      var tagged = item.properties && item.properties._reward_tier;
      if (!tagged && giftVariantIds[String(item.variant_id)]) {
        steps.push(this.removeGift.bind(this, item));
      } else if (tagged && liveTier[tagged] !== String(item.variant_id)) {
        // A reward line from a tier that no longer exists (yesterday's gift, or the other
        // region's ladder) comes out, so the right gift can go in.
        steps.push(this.removeGift.bind(this, item));
      }
    }.bind(this));

    this.tiers.forEach(function (tier) {
      if (!tier.variant_id) return;

      var unlocked = subtotal >= tier.threshold_cents;
      var existing = cart.items.filter(function (item) {
        return item.properties && item.properties._reward_tier === tier.id &&
          String(item.variant_id) === String(tier.variant_id);
      })[0];

      if (unlocked && !existing) {
        steps.push(this.addGift.bind(this, tier));
      } else if (!unlocked && existing) {
        steps.push(this.removeGift.bind(this, existing));
      } else if (unlocked && existing && existing.quantity > 1) {
        // One gift per order, however the quantity was raised.
        steps.push(this.setGiftQuantity.bind(this, existing, 1));
      }
    }.bind(this));

    if (!steps.length) return Promise.resolve();

    // Run cart writes one at a time so they cannot overwrite each other.
    return steps.reduce(function (chain, step) {
      return chain.then(step);
    }, Promise.resolve()).then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  };

  CartRewardsBar.prototype.addGift = function (tier) {
    var url = routes().cartAdd || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: tier.variant_id,
        quantity: 1,
        properties: { _reward_tier: tier.id }
      })
    }).catch(function () {});
  };

  CartRewardsBar.prototype.removeGift = function (item) {
    return this.setGiftQuantity(item, 0);
  };

  CartRewardsBar.prototype.setGiftQuantity = function (item, quantity) {
    var url = routes().cartChange || '/cart/change.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: item.key, quantity: quantity })
    }).catch(function () {});
  };

  // Clone the hidden source bar into every slot present on the page:
  // the cart drawer (#CartRewardsBarSlot) and the full cart page
  // (#CartRewardsBarSlotCart). Cloning (not moving) lets it appear in both.
  var SLOT_IDS = ['CartRewardsBarSlot', 'CartRewardsBarSlotCart'];

  function placeBars() {
    var template = document.getElementById('CartRewardsBarTemplate');
    if (!template) return;
    var source = template.querySelector('[data-cart-rewards-bar]');
    if (!source) return;

    SLOT_IDS.forEach(function (slotId) {
      var slot = document.getElementById(slotId);
      if (!slot) return;
      if (slot.querySelector('[data-cart-rewards-bar]')) return; // already placed
      slot.innerHTML = '';
      slot.appendChild(source.cloneNode(true));
    });
  }

  function init() {
    placeBars();
    var template = document.getElementById('CartRewardsBarTemplate');
    document.querySelectorAll('[data-cart-rewards-bar]').forEach(function (el) {
      if (template && template.contains(el)) return; // skip the hidden source
      if (el.cartRewardsBarInstance) return;
      el.cartRewardsBarInstance = new CartRewardsBar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the merchant edits this section's settings/blocks in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
